if(!customElements.get('product-card')) {
  customElements.define('product-card', class extends HTMLElement {
    constructor() {
      super();

      this.fetchUrl = this.getAttribute('data-fetch-url');
    }

    getProductCardTemplate() {
      fetch(this.fetchUrl)
        .then(response => response.text())
        .then(html => {
          const fullCardContent = document.createElement('div');
          fullCardContent.innerHTML = html;

          // updates skeleton card top inner
          const currentCardContent = this.querySelector('.card__inner .card__content');
          const newCardContent = fullCardContent.querySelector('.card__inner .card__content');
          if (currentCardContent && newCardContent) {
            currentCardContent.innerHTML = newCardContent.innerHTML;
          }

          // updates skeleton card quick add
          const currentQuickAdd = this.querySelector('.card__inner .quick-add');
          const newQuickAdd = fullCardContent.querySelector('.card__inner .quick-add');
          if (currentQuickAdd && newQuickAdd) {
            currentQuickAdd.innerHTML = newQuickAdd.innerHTML;
          }

          // updates skeleton card main content
          const currentProductContent = this.querySelector('.card-product__content');
          const newProductContent = fullCardContent.querySelector('.card-product__content');
          if (currentProductContent && newProductContent) {
            currentProductContent.innerHTML = newProductContent.innerHTML;
          }

          // update skeleton image alt text
          const currentImage = this.querySelector('picture').querySelector('img');
          const newImageAltText = fullCardContent.querySelector('picture').querySelector('img').alt;
          if (currentImage && newImageAltText) {
            currentImage.alt = newImageAltText;
          }

          this.classList.remove('lazy-load');
          this.dispatchEvent(new CustomEvent('product-card-loaded', { bubbles: true }));
        })
        .catch(error => {
          console.error('Error fetching product card template:', error);
        });
    }

    connectedCallback() {
      if (this.classList.contains('lazy-load')) {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                entry.target.getProductCardTemplate();
              }
            });
          },
          {
            threshold: 0.2,
            rootMargin: '0px'
          }
        );

        this.observer.observe(this);
      }
    }
  })
}